import { render, staticRenderFns } from "./vehiclesDetail.vue?vue&type=template&id=8ad23ace&scoped=true"
import script from "./vehiclesDetail.vue?vue&type=script&lang=js"
export * from "./vehiclesDetail.vue?vue&type=script&lang=js"
import style0 from "./vehiclesDetail.vue?vue&type=style&index=0&id=8ad23ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad23ace",
  null
  
)

export default component.exports